<div class="autoDetailRates__header">
  <div class="autoDetailRates__header-title">
    <app-ds-typography
      [text]="'AUTOS_MODULE.RATES.TITLE' | transloco"
      [fontFamily]="fontFamily.SemiBold"
      [tag]="'h3'"
      [color]="fontColor.Primary"
      [size]="isUserHistory ? fontSize.RG : fontSize.XS">
    </app-ds-typography>
  </div>
  <div class="autoDetailRates__header-subtitle">
    <app-ds-typography
      [text]="'AUTOS_MODULE.RATES.TEXT' | transloco"
      [tag]="'p'"
      [color]="fontColor.Secondary"
      [size]="fontSize.XXS">
    </app-ds-typography>
  </div>
</div>
<div class="autoDetailRates__detail" [class.user-history]="isUserHistory">
  <app-payment-detail-cont
    [isModal]="false"
    [showInfo]="false"
    [isMobile]="true"
    [total]="total"
    [currencyCode]="currency"
    [isLoading]="!rates"
    [discount]="discount$ | async"
    [conversionRate]="conversionRate"
    [customTitle]="period"
    [subtitles]="[]"
    [rows]="rows">
  </app-payment-detail-cont>
</div>
